import { defineComponent, h } from 'vue';
import { QSelect } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
import DesignerRegistryMixin from './DesignerRegistryMixin.jsx';

export default defineComponent({
    name: 'combo-box-dsgn',
    mixins: [DesignerRegistryMixin],
    components: { QSelect },
    data: function () {
        return {
            model: null,
        }
    },
    created() {
    },
    computed: {
        Root: function () {
            return this.root;
        },
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedModel == this.designmodel;
        },
        sizeStyle() {
            return utils.getSize(this.controlData.SizeOptions, this.parentType, this.$parent);
        },
        containerStyles() {
            let styles = {
                ...utils.resolveStyleHints(this.controlData.StyleHints, this),
                ...this.sizeStyle,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            };
            return styles;
        },
    },
    methods: {
        ...methods,
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
    },
    props: {
        name: '',
        root: null,
        rowData: null,
        designmodel: null,
        parentType: '',
        controlData: {}
    },
    render() {
        return (
            <div
                style={this.containerStyles}
                class={{ 'c-ComboBox': true, 'designer-container': true, selected: this.selected$, 'q-ma-xs': true }}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                <QSelect
                    style="width: 100%"
                    optionLabel="label"
                    optionValue="value"
                    emitValue
                    mapOptions
                    modelValue={this.model}
                    placeholder={this.controlData.PlaceHolder}
                    useInput
                    fillInput
                    hideSelected
                    hideBottomSpace
                    dense
                    outlined
                ></QSelect>
            </div>
        );
    }
});